import { FC, useState, useEffect } from "react";
import { Popover } from "@headlessui/react";
import { UserPlusIcon } from "@heroicons/react/24/outline";
// import ClearDataButton from "components/HeroSearchForm/ClearDataButton";
import { getHotelSelectedData } from "services/get-hotel-selected-data";

export interface GuestsInputProps {
  className?: string;
}

const GuestsInputForm: FC<GuestsInputProps> = ({ className = "flex-1" }) => {
  const [guestAdultsInputValue, setGuestAdultsInputValue] = useState<number>(1);
  const [guestChildrenInputValue, setGuestChildrenInputValue] =
    useState<number>(0);
  // const [hotelSelectedStorage, setHotelSelectedStorage] = useState<
  //   RootHotelSelected | undefined
  // >();

  useEffect(() => {
    const hotelSelected = getHotelSelectedData();
    if (hotelSelected) {
      // setHotelSelectedStorage(hotelSelected);
      const guestAdultsTotal = hotelSelected?.guests.adults ?? 1;
      let guestChildrenTotal = 0;
      if (hotelSelected?.guests.children) {
        guestChildrenTotal = hotelSelected?.guests.children;
      }

      setGuestAdultsInputValue(guestAdultsTotal);
      setGuestChildrenInputValue(guestChildrenTotal);
    }
  }, []);

  // const { guests, setGuests } = useHotels();

  // const handleChangeData = (value: number, type: keyof GuestsObject) => {
  //   let newValue = {
  //     guestAdults: guestAdultsInputValue,
  //     guestChildren: guestChildrenInputValue,
  //   };
  //   if (type === "guestAdults") {
  //     setGuestAdultsInputValue(value);
  //     newValue.guestAdults = value;
  //     const newGuests = {
  //       ...guests,
  //       NumAdults: value,
  //       Quantity: value + newValue.guestChildren,
  //     };

  //     setGuests(newGuests);

  //     localStorage.setItem(
  //       "hotelSelected",
  //       JSON.stringify({ ...hotelSelectedStorage, guests: newGuests })
  //     );
  //   }
  //   if (type === "guestChildren") {
  //     setGuestChildrenInputValue(value);
  //     newValue.guestChildren = value;
  //     const arrayChildrenAges = Array(value).fill(5);
  //     const newGuests = {
  //       ...guests,
  //       ChildAges: arrayChildrenAges,
  //       Quantity: value + newValue.guestAdults,
  //     };
  //     setGuests(newGuests);
  //     localStorage.setItem(
  //       "hotelSelected",
  //       JSON.stringify({ ...hotelSelectedStorage, guests: newGuests })
  //     );
  //   }
  // };

  const totalGuests = guestChildrenInputValue + guestAdultsInputValue;

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };
    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => window.removeEventListener("beforeunload", handleBeforeUnload);
  }, []);

  return (
    <Popover className={`flex relative ${className}`}>
      {({ open }) => (
        <>
          <div
            className={`md:w-full flex items-center justify-center md:mx-auto focus:outline-none rounded-b-3xl ${
              open ? "shadow-none" : ""
            }`}
          >
            <Popover.Button
              className={`relative z-10 justify-center text-left mx-auto flex items-center p-3 space-x-3 cursor-default focus:outline-none`}
            >
              <div className="text-neutral-300 dark:text-neutral-400">
                <UserPlusIcon className="w-5 h-5 lg:w-7 lg:h-7" />
              </div>
              <div className="flex-grow">
                <span className="block xl:text-lg font-semibold">
                  {totalGuests < 2
                    ? ` ${totalGuests} Hóspede`
                    : ` ${totalGuests} Hóspedes`}
                </span>
                <span className="block mt-1 text-sm text-neutral-400 leading-none font-light">
                  {totalGuests ? "Hóspedes" : "Adicionar hóspedes"}
                </span>
              </div>

              {/* {!!totalGuests && open && (
                <ClearDataButton
                  onClick={() => {
                    setGuestAdultsInputValue(1);
                    setGuestChildrenInputValue(0);
                  }}
                />
              )} */}
            </Popover.Button>
          </div>

          {/* <Transition
            as={Fragment}
            enter="transition ease-out duration-200"
            enterFrom="opacity-0 translate-y-1"
            enterTo="opacity-100 translate-y-0"
            leave="transition ease-in duration-150"
            leaveFrom="opacity-100 translate-y-0"
            leaveTo="opacity-0 translate-y-1"
          >
            <Popover.Panel className="absolute right-0 z-10 w-full sm:min-w-[340px] max-w-sm bg-white dark:bg-neutral-800 top-full mt-3 py-5 sm:py-6 px-4 sm:px-8 rounded-3xl shadow-xl ring-1 ring-black ring-opacity-5 ">
              <NcInputNumber
                className="w-full"
                // defaultValue={guestAdultsInputValue}
                defaultValue={1}
                onChange={(value) => handleChangeData(value, "guestAdults")}
                max={10}
                min={1}
                label="Adultos"
                desc="13 anos ou mais "
                />
              <NcInputNumber
                className="w-full mt-6"
                // defaultValue={guestChildrenInputValue}
                defaultValue={0}
                onChange={(value) => handleChangeData(value, "guestChildren")}
                max={4}
                min={0}
                label="Crianças"
                desc="De 3 a 12 anos"
              />
              <Popover.Button
                className="w-full mt-10 py-3 bg-[--green] hover:bg-[--green-dark] rounded-3xl text-neutral-50 transition-colors duration-300 ease-in-out"
              >
                Buscar quartos
              </Popover.Button>
            </Popover.Panel>
          </Transition> */}
        </>
      )}
    </Popover>
  );
};

export default GuestsInputForm;
